import React from 'react';

import { styled } from '@mui/material/styles';

import { SMALL_MARGIN_PX, SMALL_RADIUS_PX } from '~/theme';

const FlatPaper = (props) => {
  return <Wrapper {...props} />;
};

export default FlatPaper;

const Wrapper = styled('div')`
  padding: ${SMALL_MARGIN_PX};
  background: ${({ theme }) => theme.palette.common.blackSecondary};
  border-radius: ${SMALL_RADIUS_PX};
`;
